module.exports = __webpack_public_path__ + "static/img/team_honor_jijun.c2648361.png";